var ELLIPSIS_STR = ' ...';
function insertBR(text) {
  return text.trim().replace(/(\r\n?|\n)\s\.{3}/g, ELLIPSIS_STR).replace(/\r\n?|\n/g, '<br>').replace('<br>' + ELLIPSIS_STR, ELLIPSIS_STR);
}
function text2HTML(text, pClassName, appendToEnd) {
  // 1: Plain Text Search
  var _text = insertBR(text);

  // 3: Paragraphs
  _text = _text.replace(/<br>\s*<br>/g, "</p><p class=\"".concat(pClassName, "\">"));

  // 4: Wrap in Paragraph Tags
  _text = "<p class=\"".concat(pClassName, "\">").concat(_text).concat(appendToEnd ? ' ' + appendToEnd : '', "</p>");
  return _text;
}

export { ELLIPSIS_STR, insertBR, text2HTML };
//# sourceMappingURL=utils.esm.js.map
